import { Box } from '@material-ui/core';
import CustomTextField from 'components/CustomTextField';
import LoadingButton from 'components/LoadingButton';
import i18n from 'i18n';
import validateForm from 'pages/signin/utils';
import { validatePasswordConfirm } from 'pages/signup/utils';
import { FunctionComponent, ChangeEvent, useState } from 'react';
import BackToLogin from './BackToLogin';

interface FormI {
  onSave: (password: string) => void;
  isLoading: boolean;
}

const Form: FunctionComponent<FormI> = ({ onSave, isLoading }: FormI) => {
  const [formData, setFormData] = useState({
    password: '',
    passwordConfirm: '',
    errors: {
      password: '',
      passwordConfirm: ''
    }
  });

  const onChangeField = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;
    setFormData({
      ...formData,
      errors: {
        ...formData.errors,
        [name]: validateForm(name, value),
        passwordConfirm: validatePasswordConfirm(formData, name, value)
      },
      [e.currentTarget.name]: e.currentTarget.value
    });
  };

  const btnDisabled =
    Object.values(formData.errors).some(e => !!e) ||
    !formData.password ||
    !formData.passwordConfirm;

  return (
    <Box display="flex" flexDirection="column" gridGap={24}>
      <Box display="flex" flexDirection="column" gridGap={20}>
        <CustomTextField
          label={i18n.t('pages.signup.formLabel.password')}
          placeholder="●●●●●●●●●"
          name="password"
          type="password"
          helperText={
            !!formData.errors.password &&
            i18n.t('pages.signup.helperText.password')
          }
          value={formData.password}
          error={!!formData.errors.password}
          onChange={onChangeField}
        />

        <CustomTextField
          label={i18n.t('pages.signup.formLabel.passwordConfirm')}
          placeholder="●●●●●●●●●"
          name="passwordConfirm"
          type="password"
          value={formData.passwordConfirm}
          error={!!formData.errors.passwordConfirm}
          onChange={onChangeField}
        />
      </Box>

      <LoadingButton
        label={i18n.t('button.resetPassword')}
        isLoading={isLoading}
        type="submit"
        fullWidth
        disabled={btnDisabled}
        variant="contained"
        color="primary"
        onClick={() => onSave(formData.password)}
      />
      <BackToLogin />
    </Box>
  );
};

export default Form;
